// extracted by mini-css-extract-plugin
module.exports = {"trim":"quote-list_trim__9rafN","row":"quote-list_row__4XDK4"};